import { GraphqlService } from "../../graphql/graphql.service";
import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class PinnedReportsService extends GraphqlService {

  getPinnedReports() {
    return this.apollo.query<any>({
      query: gql`
        query GetPinnedReports {
          pinnedReports {
            edges {
              node {
                id
                report
                label
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
    }).pipe(
      map((response) => response.data.pinnedReports.edges.map(item => item.node)),
    );
  }

  addPinnedReport(name: string, url: string) {
    return this.apollo.mutate({
      mutation: gql`
        mutation AddPinnedReport($name: String!, $url: String!) {
          pinReport(label: $name, report: $url) {
            pinnedReport {
              id
              report
              label
            }
          }
        }
      `,
      variables: { name, url },
    });
  }

  removePinnedReport(id: string) {
    return this.apollo.mutate({
      mutation: gql`
        mutation RemovePinnedReport($id: UUID!) {
          unpinReport(id: $id) {
            pinnedReport {
              id
            }
          }
        }
      `,
      variables: { id },
    });
  }
}
